import React from 'react';
//import { useSelector } from 'react-redux';

// These are regular React components we will write soon
import RemoveElementModal from './RemoveElementModal';
import RemoveMultipleElementsModal from './RemoveMultipleElementsModal';
import RemoveDeviceModal from './RemoveDeviceModal';
import RemoveStreamModal from './RemoveStreamModal';
import RemoveMultipleStreamsModal from './RemoveMultipleStreamsModal';
import RemoveLocationModal from './RemoveLocationModal';
import RemoveUserModal from './RemoveUserModal';
import WrongResolutionWarning from './WrongResolutionWarning';
import CloseUnsavedFormConfirmationModal from './CloseUnsavedFormConfirmationModal';
import { MicastAssignModalForm, AssignMirrorWizzard } from '../../content/DevicesPage';
import { SelectStreamModal } from '../../content/StreamsPage';
import InformAboutLostChangesStreamNewModal from './InformAboutLostChangesStreamNewModal';
import { SelectElementModal } from '../../content/StreamsPage';
import AddFeature from './../DeviceFeatures/AddFeature.modal';
import FeatureSettings from './../DeviceFeatures/FeatureSettings.modal';
import LocationWizard from '../../content/LocationsPage/LocationWizard';
import ConfirmPasswordResetModal from './ConfirmPasswordResetModal';
import ChangePasswordModal from './ChangePasswordModal';
import { NoLocationWarning } from './NoLocationWarning.modal';
import { NoFreeLicences } from './NoFreeLicences.modal';
import { VideoModal } from '../Help/VideoModal';
import { WelcomeModal } from '../Help/WelcomeModal';

import { useSpring, animated } from 'react-spring';
import { useModalContext } from '@/contexts/ModalContextProvider';
import { useHideModal } from '@/lib/hooks/useModal';
import ChangeGroupsForMultipleElementsModal from '../GroupsSelection/Modal';
import ConfirmSomethingModal from './ConfirmSomethingModal';
import { ContactModalForm } from '../Contacts';

const MODAL_COMPONENTS = {
  DELETE_ELEMENT: RemoveElementModal,
  DELETE_ELEMENTS: RemoveMultipleElementsModal,
  DELETE_DEVICE: RemoveDeviceModal,
  DELETE_LOCATION: RemoveLocationModal,
  DELETE_STREAM: RemoveStreamModal,
  DELETE_STREAMS: RemoveMultipleStreamsModal,
  DELETE_USER: RemoveUserModal,
  CLOSE_UNSAVED_FORM_MODAL: CloseUnsavedFormConfirmationModal,
  NEW_STREAM_LOST_UNSAVED_MODAL: InformAboutLostChangesStreamNewModal,
  CREATE_DEVICE: MicastAssignModalForm,
  SELECT_STREAM: SelectStreamModal,
  SELECT_ELEMENT: SelectElementModal,
  WRONG_RESOLUTION: WrongResolutionWarning,
  ADD_FEATURES: AddFeature,
  FEATURE_SETTINGS: FeatureSettings,
  LOCATION_WIZARD: LocationWizard,
  CONFIRM_PASSWORD_RESET: ConfirmPasswordResetModal,
  CHANGE_PASSWORD: ChangePasswordModal,
  NO_LOCATION_WARNING: NoLocationWarning,
  NO_FREE_LICENCES: NoFreeLicences,
  SHOW_VIDEO: VideoModal,
  SHOW_WELCOME: WelcomeModal,
  CREATE_MIRROR_DEVICE: AssignMirrorWizzard,
  CHANGE_GROUPS_FOR_ELEMENTS: ChangeGroupsForMultipleElementsModal,
  CONFIRM_REMOVE: ConfirmSomethingModal,
  CONTACTS_FORM: ContactModalForm,
  /* other modals */
};

const ModalRoot = () => {
  const props = useSpring({ opacity: 1, from: { opacity: 0 } });
  const { modalType, modalProps, } = useModalContext();
  const hideModal = useHideModal();

  if (!modalType) {
    return null;
  }
  const SpecificModal = MODAL_COMPONENTS[modalType];
  const NewModal = (
    <animated.div style={props}>
      <SpecificModal {...modalProps} hideModal={hideModal} />
    </animated.div>
  );

  return NewModal;
};

export default ModalRoot;
